"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhookToolApiSchemaConfigInput = void 0;
const serializers = __importStar(require("../index"));
const core = __importStar(require("../../core"));
const WebhookToolApiSchemaConfigInputMethod_1 = require("./WebhookToolApiSchemaConfigInputMethod");
const LiteralJsonSchemaProperty_1 = require("./LiteralJsonSchemaProperty");
const QueryParamsJsonSchema_1 = require("./QueryParamsJsonSchema");
const WebhookToolApiSchemaConfigInputRequestHeadersValue_1 = require("./WebhookToolApiSchemaConfigInputRequestHeadersValue");
const AuthConnectionLocator_1 = require("./AuthConnectionLocator");
exports.WebhookToolApiSchemaConfigInput = core.serialization.object({
    url: core.serialization.string(),
    method: WebhookToolApiSchemaConfigInputMethod_1.WebhookToolApiSchemaConfigInputMethod.optional(),
    pathParamsSchema: core.serialization.property("path_params_schema", core.serialization.record(core.serialization.string(), LiteralJsonSchemaProperty_1.LiteralJsonSchemaProperty).optional()),
    queryParamsSchema: core.serialization.property("query_params_schema", QueryParamsJsonSchema_1.QueryParamsJsonSchema.optional()),
    requestBodySchema: core.serialization.property("request_body_schema", core.serialization.lazyObject(() => serializers.ObjectJsonSchemaPropertyInput).optional()),
    requestHeaders: core.serialization.property("request_headers", core.serialization
        .record(core.serialization.string(), WebhookToolApiSchemaConfigInputRequestHeadersValue_1.WebhookToolApiSchemaConfigInputRequestHeadersValue)
        .optional()),
    authConnection: core.serialization.property("auth_connection", AuthConnectionLocator_1.AuthConnectionLocator.optional()),
});
